import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {getMaintenance} from "../../../api/MaintenancesApi";
import UnitsApi from "../../../api/UnitsApi";
import ProfileHeader from "../../../components/ProfileHeader";
import {Box} from "@mui/material";
import {Trans} from "react-i18next";
import Stack from "@mui/material/Stack";
import BottomNav from "../../../components/BottomNav";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import moment from 'moment'

const ViewMaintenance = () => {
  const { id } = useParams();
  const [maintenance, setMaintenance] = useState(null)
   const [unit, setUnit] = useState(null)
  const [showBackdrop, setShowBackdrop] = useState(true)

  useEffect(() => {
   

    getMaintenance(id).then(resp => {
      setMaintenance(resp?.data)

      UnitsApi.getId(resp?.data?.unit?.id).then((result) => {
        UnitsApi.get(result?.data?.numberPlate).then((resUnit) => {
        setUnit(resUnit?.data)
      });
      })

    }).catch((e) => {
      console.log()
    }).finally(() => {
      setShowBackdrop(false)
      })
  }, [])

  return (
    <Box>
      <ProfileHeader />
      <Box className="create-maintenance-title">
       Detalle de Orden de Mantenimiento
        <Stack
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
        >
          <Box flexGrow="1" textAlign="left" pl={3}>
            {/*//<span className={`status-box ${getClassStatus(data?.status)}`}>{data?.status}</span>*/}
          </Box>
          <Box flexGrow="1" textAlign="right" pr={3}>
            {/*<span className="header3">{maintenance?.date}</span>*/}
          </Box>
        </Stack>
      </Box>
      <Box className="main-content">
        <Box className="main-card">
          <Box className="create-maintenance-card-title">
            {maintenance?.unit?.numberPlate}
          </Box>
        
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Tipo de Mantenimiento</Grid>
            <Grid item xs={8} >{maintenance?.type==="SERVICE"? "Preventivo":"Correctivos"}</Grid>
          </Grid>
          <Grid container className="data-static">
          <Grid item xs={4} className="data-static-label">Subtipo de Mantenimiento</Grid>
            <Grid item xs={8} >{maintenance?.type}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Orden de Reparación Nº</Grid>
            <Grid item xs={8} >{maintenance?.idMaintenance}</Grid>
          </Grid>

          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Dominio</Grid>
            <Grid item xs={8} >{unit?.numberPlate}</Grid>
          </Grid>

          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Fecha</Grid>
            <Grid item xs={8} >{moment(maintenance?.deliveryDate).format('DD-MM-YYYY')}</Grid>
          </Grid>

          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Fecha Finalizacion</Grid>
            <Grid item xs={8} >{maintenance?.finishDate? moment(maintenance?.finishDate).format('DD-MM-YYYY'):''}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Marca</Grid>
            <Grid item xs={8} >{unit?.unitType?.brand}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Modelo</Grid>
            <Grid item xs={8} >{unit?.unitType?.model}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Nº Chasis</Grid>
            <Grid item xs={8} >{unit?.chassisID}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Nº Motor</Grid>
            <Grid item xs={8} >{unit?.engineID}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Taller</Grid>
            <Grid item xs={8} >{maintenance?.workshop}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Contacto</Grid>
            <Grid item xs={8} >{maintenance?.contact}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Km. Actuales</Grid>
            <Grid item xs={8} >{maintenance?.finalMileage}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Detalle</Grid>
            <Grid item xs={8} >{maintenance?.description}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Kms</Grid>
            <Grid item xs={8} >{maintenance?.mileage}</Grid>
          </Grid>
          <Grid container className="data-static">
            <Grid item xs={4} className="data-static-label">Observaciones</Grid>
            <Grid item xs={8} >{maintenance?.remarks}</Grid>
          </Grid>
        </Box>
      </Box>
      <BottomNav hasBack="true" />
      <Backdrop sx={{ color: '#fff' }} open={showBackdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default ViewMaintenance;
